import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { noWhitespaceValidator } from '../../../../shared/src/lib/service/helper.service';
import { UserDetailsFacade } from '@piqet-angular/data';
import { TitleCasePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss'],
  providers: [TitleCasePipe],
})
export class PersonalInfoComponent implements OnInit {
  myProfileForm!: FormGroup;

  selectedCountry: any;
  selectedState: any;
  stream: any;
  fileBase64: any;
  lastModificationdate: any;
  profileImage: any;

  submitted = false;
  updateValue = true;
  imageRequired: boolean = false;
  currentEmail: string = '';
  isEmailValid: boolean = false;
  isEmailValidationPending: boolean = true;
  lastValidatedEmail: string | null = null;
  @ViewChild('emailInput') emailInput!: ElementRef<HTMLInputElement>;

  @ViewChild('fileInput') el!: ElementRef;

  @Input() countryList: any;
  @Input() getStatesList: any;
  @Input() userPersonalData: any;
  @Input() imageData: any;

  @Output() updateUserProfileImage = new EventEmitter<any>();
  @Output() imageForMainProfile = new EventEmitter<any>();
  @Output() getStatesEvent = new EventEmitter<any>();
  @Output() savePersonalData = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef,
    public UserDetailsFacade: UserDetailsFacade,
    private cookieService: CookieService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.profileImage = this.imageData;
    this.mapCountryList();
    this.mapStateList();
    this.createForm();
    this.setFormData();
    this.cd.detectChanges();
  }

  changeEmail(event: any) {
    this.currentEmail = '';
  }

  getEmailValidation() {
    this.currentEmail = this.myProfileForm.controls['email'].value;
    this.isEmailValidationPending = false;
    if (this.userPersonalData.userName == this.myProfileForm.controls['email'].value) {
      this.isEmailValid = false;
      return;
    }
    if (this.currentEmail === this.lastValidatedEmail) {
      return;
    }
    const payload = {
      id: this.userPersonalData.aspNetUserId ?? 0,
      email: this.myProfileForm.controls['email'].value,
    };
    this.sharedService.isEmailExist(payload).subscribe((data: any) => {
      if (!data.messageType) {
        this.isEmailValid = data.data.value;
        this.lastValidatedEmail = this.currentEmail;
      }
    });
  }

  restrictSpecial(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onChange(value: any) {
    if (!!value?.id) {
      this.selectedCountry = value;
      this.myProfileForm.controls['state'].setValue(null);
      this.getStatesEvent.emit(value?.id);
    } else {
      this.myProfileForm.patchValue({ country: this.selectedCountry });
    }
  }

  createForm() {
    const reg = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
    this.myProfileForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(reg)]],
      firstName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      phone: ['', Validators.maxLength(10)],
      postCode: [''],
      country: ['', Validators.required],
      state: [null],
      image: [''],
    });
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  setFormData() {
    if (!!this.myProfileForm && !this.submitted) {
      this.myProfileForm.patchValue({
        email: this.userPersonalData.userName,
        firstName: this.userPersonalData.firstName.replace(/\s/g, ''),
        lastName: this.userPersonalData.lastName,
        phone: this.userPersonalData.phone,
        postCode: this.userPersonalData.postCode,
        country: this.selectedCountry,
        state: this.selectedState,
      });
    }
  }

  async mapCountryList() {
    this.userPersonalData?.countryList.map((item: any) => {
      if (item.id == this.userPersonalData.countryId) {
        this.selectedCountry = item;
      }
    });
    this.getStatesEvent.emit(this.selectedCountry?.id);
  }

  async mapStateList() {
    await this.userPersonalData?.stateList.map((item: any) => {
      if (item.id == this.userPersonalData.stateId) {
        return (this.selectedState = item);
      }
    });
  }
  uploadFile(event: any, userProfileImage: any) {
    if (!event.target.files && event.target.files[0]) {
      return;
    }
    const file = event.target.files[0] || event.target.files;
    this.lastModificationdate = file.lastModifiedDate?.toISOString();
    const reader = new FileReader(); // HTML5 FileReader API
    reader.readAsDataURL(file);
    // When file uploads set it to file formcontrol
    reader.onload = (event: any) => {
      this.profileImage = event.target.result;
      this.stream = reader.result;
      this.fileBase64 = this.stream.split(',')[1];
      if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
        this.imageRequired = false;
        this.imageForMainProfile.emit(this.profileImage);
      } else {
        this.imageRequired = true;
        this.myProfileForm.controls['image'].value().required();
      }
      const data = {
        id: userProfileImage !== undefined ? userProfileImage.id : 0,
        imageStr: this.fileBase64 || userProfileImage?.image,
        imageThumbStr: this.fileBase64,
        modifiedOn: this.lastModificationdate,
        userId: Number(this.cookieService.get('userId')),
      };
      this.updateUserProfileImage.emit(data);
    };
  }

  submit() {
    this.submitted = true;
    if (
      this.myProfileForm.invalid ||
      this.myProfileForm.controls['country'].value?.name == 'Country'
    ) {
      return;
    }
    if (this.myProfileForm.controls['email'].valid) {
      this.isEmailValidationPending = false;
    }
    if (this.myProfileForm.invalid || this.isEmailValid || this.isEmailValidationPending) {
      if (this.isEmailValidationPending) {
        this.emailInput.nativeElement.focus();
      }
      return;
    }
    const data = {
      userId: Number(this.cookieService.get('userId')),
      userName: this.myProfileForm.controls['email'].value,
      firstName: this.myProfileForm.controls['firstName'].value.replace(/\s/g, ''),
      lastName: this.myProfileForm.controls['lastName'].value,
      phone: this.myProfileForm.controls['phone'].value,
      postCode: this.myProfileForm.controls['postCode'].value,
      countryId: this.myProfileForm.controls['country'].value?.id,
      stateId:
        this.myProfileForm.controls['state'].value?.name == 'State'
          ? this.selectedState.id
          : this.myProfileForm.controls['state'].value?.id,
      countryName:
        this.myProfileForm.controls['country'].value?.name == 'Country'
          ? ' '
          : this.myProfileForm.controls['country'].value?.name,
      stateName:
        this.myProfileForm.controls['state'].value?.name == 'State'
          ? this.selectedState.name
          : this.myProfileForm.controls['state'].value?.name,
    };
    this.savePersonalData.emit(data);
  }

  onPhoneKeyPress(event: KeyboardEvent): void {
    const key = event.key;
    // Allow digits (0-9) and plus sign (+)
    if (!/^[0-9+]$/.test(key)) {
      event.preventDefault();
    }
  }
}
